export const algoliaAppId = process.env.APP_ENV === 'production' ? 'SU25FBOU6E' : 'GVB4GWEUVT';
export const algoliaApiKey =
    process.env.APP_ENV === 'production'
        ? 'f080575d6109f56cc9714443ae8bce91'
        : 'f07ff3671223326c28606d7332ef7d06';

export const ALGOLIA_QUERY_MAP = 'algolia_query_map';
